export const doesMessageTypeMatchSearch = (
  messageTypeId: number,
  messageTypeName: string,
  search: string,
) =>
  search.length === 0 || // Pass all options through if search string is empty
  messageTypeId.toString().includes(search.toLowerCase()) || // Pass options with matching IDs
  messageTypeName.toLowerCase().includes(search.toLowerCase()); // Pass options with matching names
